import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { projectMutationKeys } from '../constants'

export const useSetMemberRoleInProjectMutation = (options) => {
  const handleMutation = async ({ usersRoleList = [], projectId }) => {
    if (!projectId) {
      throw new Error('projectId is required')
    }

    if (!usersRoleList.length) {
      throw new Error('usersRoleList must not be empty')
    }

    // allow set different rules for different users at the same time
    const requests = usersRoleList?.map(({ userIds, role }) => {
      const config = {
        method: 'post',
        data: { userIds, role }
      }

      return api(`/api/memberships-api/projects/${projectId}/members`, config)
    })

    const responses = await Promise.all(requests)
    return responses.map(({ data }) => data)
  }

  return useMutation({
    mutationKey: projectMutationKeys.SET_MEMBER_ROLE_IN_PROJECT,
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: (data, mutationParams, context) => {
      options?.onSuccess?.(data, mutationParams, context)
    },
    onError: (error, requestParams, context) => {
      options?.onError?.(error, requestParams, context)
    }
  })
}
